// @flow

import * as React from 'react';
import styles from './VenueCard.scss';
import type { PreviewVenue } from './venueCard/types';
import PreviewImages from 'common/components/previewImages/PreviewImages';
import VenuePreviewPrice from './venueCard/VenuePreviewPrice';
import VenueInfo from './venueCard/VenueInfo';
import VenueLink from './venueCard/VenueLink';

export type Props = {|
  venue: PreviewVenue,
  onClickVenueLink?: () => void,
  openInNewTab: boolean
|};

export default function VenueCard(props: Props) {
  const { venue, onClickVenueLink, openInNewTab } = props;

  return (
    <VenueCardContainer>
      <VenueImage
        venue={venue}
        onClickVenueLink={onClickVenueLink}
        openInNewTab={openInNewTab}
      />
      <VenueInfo
        venue={venue}
        onClickVenueLink={onClickVenueLink}
        openInNewTab={openInNewTab}
      />
    </VenueCardContainer>
  );
}

export function VenueCardContainer(props: { children: React.Node, ... }) {
  return <div className={styles.venueCard}>{props.children}</div>;
}

export function VenueImageContainer(props: { children: React.Node, ... }) {
  return <div className={styles.imageContainer}>{props.children}</div>;
}

export function VenueCityOverlay(props: { city: string | null, ... }) {
  const { city } = props;

  return (
    <div className={styles.venueCityOverlay}>
      <span className={styles.venueCity}>{city}</span>
    </div>
  );
}

function VenueImage(props) {
  const { venue, onClickVenueLink, openInNewTab } = props;

  return (
    <VenueImageContainer>
      <PreviewImages
        images={venue.preview_images}
        linkWrapper={({ children }) => (
          <VenueLink
            venue={venue}
            openInNewTab={openInNewTab}
            onClickVenueLink={onClickVenueLink}
          >
            {children}
          </VenueLink>
        )}
      />
      <VenuePreviewPrice venue={venue} />
      <VenueCityOverlay city={venue.city} />
    </VenueImageContainer>
  );
}
